<template>
  <el-card :style="bodyStyle"
           shadow="never">
    <div>
      <!-- 订单数据： 未处理订单数，日订单数，交易金额，盈利
      月订单数，交易金额，盈利' -->
      <div>
        <!-- <span class="demonstration">统计日期：</span>
        <el-date-picker
          size="mini"
          v-model="dataRange"
          type="daterange"
          range-separator="至"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
        >
        </el-date-picker> -->
        <!-- 本月 -->
        <!-- <el-button
          style="margin-left: 20px"
          type="primary"
          :plain="true"
          size="mini"
          @click="choiceThisMonth"
          >本月</el-button
        > -->
        <!-- 上个月 -->
      </div>
      <div class="data-date">当前版本 v2.1.0 </div>
      <div v-if="is_staff">
        <div style="width:auto;text-align:center;"> 请联系管理员获取权限</div>

      </div>
      <div v-else>
        <!--  -->
        <div class="booking-sell-area">
          <div class="booking-member-item">
            <div style="display:flex;justify-content:space-between">
              <div class="item-member-num">当前会员人数：{{members_num}}</div>
              <div class="item-member-num">预订服务次数：{{booking_contact}}</div>
            </div>

          </div>
        </div>
        <!-- 金额 -->
        <div class="booking-sell-area">
          <div class="booking-sell-item"
               style="background-color: #fa8072">
            <span class="sell_name">本月销售额：</span>
            <span class="sell_num">{{ sales / 100 }}</span>
            <span class="sell_num_yuan">元</span>
          </div>
          <div class="booking-sell-item"
               style="background-color: #5dade2">
            <span class="sell_name">本月利润：</span>
            <span class="sell_num">{{ profit/ 100 }}</span>
            <span class="sell_num_yuan">元</span>
          </div>
        </div>

        <!-- 数据 -->
        <div class="booking-data-area">
          <!--  -->
          <div class="booking-data-item"
               style="background-color: #ec7063">
            <span class="booking-data-item-title">未处理或待处理订单：</span>

            <p class="booking-data-item-num">
              {{ wait_accept }}
            </p>
            最近未处理订单日期：
            <p>{{ wait_accept_near_date }}</p>
          </div>
          <!--  -->
          <div class="booking-data-item"
               style="background-color: #82e0aa">
            <span class="booking-data-item-title">本月当前订单数：</span>

            <p class="booking-data-item-num">
              <span>{{ num }}</span>
            </p>
          </div>
          <!--  -->
          <div class="booking-data-item"
               style="background-color: #aed6f1">
            <span class="booking-data-item-title">当前总出行人数：</span>

            <p class="booking-data-item-num">
              {{ people_num }}
            </p>
          </div>
          <!--  -->
          <div class="booking-data-item"
               style="background-color: #e59866">
            <span class="booking-data-item-title">上个月订单数：</span>

            <p class="booking-data-item-num">
              {{ last_num }}
            </p>
          </div>
          <!--  -->
          <div class="booking-data-item"
               style="background-color: #e59866">
            <span class="booking-data-item-title">上个月出行人数：</span>
            <p class="booking-data-item-num">
              {{ last_people_num }}
            </p>
          </div>
        </div>

      </div>
    </div>

    <div @click="next()">
      <lottie :options="heartOptions"
              :height="200"
              :width="200"
              v-on:animCreated="heartAnimation" />
    </div>
  </el-card>
</template>

<script>
let clientHeight = document.documentElement.clientHeight
let contentHeight = clientHeight - 151
import lottie from '../../components/common/other/Lottie.vue'
import heartdata from '../../assets/json/data.json'
export default {
  name: 'booking-data',
  components: {
    lottie,
  },
  // mixins: [mixinTestMethods],
  data() {
    return {
      //lottie动画
      heartOptions: {
        animationData: heartdata,
        loop: false,
        autoplay: false,
      },
      heartanim: null,
      Direction: -1,

      is_staff: true,
      bodyStyle: `min-height: ${contentHeight}px`,
      // 日期
      deal_with_booking: '',
      date: '',
      std: '',
      edt: '',
      last_std: '',
      last_etd: '',
      sell_price_total: '',
      commission: '',
      wait_accept: '',
      wait_accept_near_date: '',
      // 上个月数据
      last_month_booking_account: '',
      last_month_num_people: '',
      last_month_sell_price_total: '',
      last_month_commission: '',
      // 费用
      sales: '',
      num: '',
      profit: '',
      people_num: '',
      last_sales: '',
      last_num: '',
      last_profit: '',
      last_people_num: '',
      members_num: '',
      booking_contact: '',
    }
  },
  created() {
    // 判断张类型是否是员工
    this.$http.get(`/user/get_user_type`).then((res) => {
      console.log(res)
      if (res.data.type == true) {
        this.is_staff = true
      } else {
        this.is_staff = false
        // 获取日期
        this.getYear()
        this.getBookingDate()
      }
    })
  },
  methods: {
    heartAnimation: function (anim) {
      this.heartanim = anim
      if (this.Direction == -1) {
        this.heartanim.goToAndStop(64, true)
      }
    },
    next() {
      if (this.Direction > 0) {
        this.Direction = -1
        this.heartanim.setDirection(this.Direction)
        this.heartanim.play()
        console.log(1)
      } else {
        this.Direction = 1
        this.heartanim.setDirection(this.Direction)
        this.heartanim.play()
        console.log(2)
      }
    },
    // 获取会员人数
    getTripPlanDate() {
      this.$http
        .get(`/statistics/operating/members_num?account_type=0`)
        .then((res) => {
          if (res.data.errno == '0') {
            this.members_num = res.data.members
            this.booking_contact = res.data.contact
          }
        })
    },
    // 当月 【当前】利润、人数
    getMonthlyProfitVolume() {
      this.$http
        .get(
          `/statistics/monthly_profit_volume?std=${this.std}&etd=${this.date}`
        )
        .then((res) => {
          if (res.data.errno == '0') {
            this.profit = res.data.profit
            this.people_num = res.data.num
          } else {
            this.$message({
              message: res.data.errmsg,
              type: 'error',
            })
          }
        })
    },
    // 获取当月销售额、订单数
    getMonthlySalesVolume() {
      this.$http
        .get(`/statistics/monthly_sales_volume?std=${this.std}&etd=${this.etd}`)
        .then((res) => {
          if (res.data.errno == '0') {
            this.sales = res.data.sales
            this.num = res.data.num
          } else {
            this.$message({
              message: res.data.errmsg,
              type: 'error',
            })
          }
        })
    },
    // 获取上个月销售额、订单数
    getLastMonthlySalesVolume() {
      this.$http
        .get(
          `/statistics/monthly_sales_volume?std=${this.last_std}&etd=${this.last_etd}`
        )
        .then((res) => {
          if (res.data.errno == '0') {
            this.last_sales = res.data.sales
            this.last_num = res.data.num
          } else {
            this.$message({
              message: res.data.errmsg,
              type: 'error',
            })
          }
        })
    },
    // 获取上个月成本、人数
    getLsatMonthlyProfitVolume() {
      this.$http
        .get(
          `/statistics/monthly_profit_volume?std=${this.last_std}&etd=${this.last_etd}`
        )
        .then((res) => {
          if (res.data.errno == '0') {
            this.last_profit = res.data.profit
            this.last_people_num = res.data.num
          } else {
            this.$message({
              message: res.data.errmsg,
              type: 'error',
            })
          }
        })
    },
    // 未处理订单
    getBookingDate() {
      this.$http
        .get(`/booking/list?page_number=1&page_size=1&status=1`)
        .then((res) => {
          if (res.data.errno == '0') {
            this.wait_accept = res.data.data.wait_accept
            this.wait_accept_near_date = res.data.data.wait_accept_near_date
            // 获取当月数据
            this.getMonthlySalesVolume()
            this.getMonthlyProfitVolume()
            // 获取上个月数据
            this.getLastMonthlySalesVolume()
            this.getLsatMonthlyProfitVolume()
            this.getTripPlanDate()
          } else {
            this.$message({
              message: res.data.errmsg,
              type: 'error',
            })
          }
        })
    },

    // 获取日期
    getYear() {
      let date = new Date()
      let year = date.getFullYear()
      // console.log('当前年：')
      // console.log(year)
      let month = date.getMonth() + 1
      // console.log('当前月：')
      // console.log(month)
      let day = date.getDate()
      // console.log("当前日期");
      // console.log(day)
      let lastDayObj = new Date(year, month, 0)
      // 最后一天
      let lastDay = lastDayObj.getDate()
      // console.log('当前月最后一天：')
      // console.log(lastDay)

      if (month >= 10) {
        // 本月 始末 日期
        this.std = year + '-' + month + '-' + '1'
        this.etd = year + '-' + month + '-' + lastDay
        this.date = year + '-' + month + '-' + day
      } else if (month < 10) {
        // 本月 始末 日期
        this.std = year + '-' + 0 + month + '-' + '1'
        this.etd = year + '-' + 0 + month + '-' + lastDay
        this.date = year + '-' + 0 + month + '-' + day
      }
      // console.log(this.std)
      // console.log(this.etd)
      // console.log(this.date)
      // console.log(lastDay)

      // 当前月为一月份
      console.log('上个月')
      if (month - 1 == 0) {
        let new_year = year - 1
        let last_month = 12
        this.last_std = new_year + '-' + 0 + last_month + '-' + '01'
        this.last_etd = new_year + '-' + 0 + last_month + '-' + '31'
      } else if (month - 1 == 2) {
        // 上个月为2月份
        let last_month = month - 1
        // console.log('上个月为')
        // console.log(last_month)
        let lastDay = new Date(year, last_month, 0).getDate()
        // console.log('上个月最后一天')
        // console.log(lastDay)
        this.last_std = year + '-' + 0 + last_month + '-' + '01'
        this.last_etd = year + '-' + 0 + last_month + '-' + lastDay
      } else if (month >= 10) {
        let last_month = month - 1
        // 上个月
        console.log(last_month)
        console.log(year)
        console.log(lastDay)

        let lastDay = new Date(year, last_month, 0).getDate()
        // 本月 始末 日期
        this.last_std = year + '-' + last_month + '-' + '01'
        this.last_etd = year + '-' + last_month + '-' + lastDay
      } else if (month < 10) {
        let last_month = month - 1
        let lastDay = new Date(year, last_month, 0).getDate()
        // 本月 始末 日期
        this.last_std = year + '-' + 0 + last_month + '-' + '01'
        this.last_etd = year + '-' + 0 + last_month + '-' + lastDay
      }

      console.log(this.last_std)
      console.log(this.last_etd)
    },
    testCopy() {
      let infor = 'sdfsdfsf'
      // 复制订单信息
      this.$copyText(infor).then((res) => {
        this.$message({
          message: '该订单信息已复制到剪贴板',
          type: 'success',
        })
      })

      // this.$http.get(`/booking/detail?booking_id=289`).then((res) => {
      //   console.log(res);
      // });
      // 发送请求
      // this.$http
      //   .get(`/test-flypig-detail?bookingID=1084520386810904257`)
      //   .then((res) => {
      //     console.log(res);
      //   });
    },
  },
}
</script>

<style>
.data-date {
  text-align: center;
  background-color: rgb(224, 224, 224);
  padding: 10px 0;
  margin: 0 10px;
}
.booking-sell-area {
  display: flex;
  justify-content: center;
  margin-top: 20px;
  margin-bottom: 20px;
}
.booking-sell-item {
  height: 80px;
  width: 45%;
  background-color: blanchedalmond;
  border: 1px solid lightgrey;
  margin: auto;
  padding: 10px;
  border-radius: 5px;
  text-align: center;
  box-shadow: 5px 5px 10px 0.01px rgb(211, 211, 211);
}
.booking-member-item {
  height: 80px;
  width: 95%;
  background-color: blanchedalmond;
  border: 1px solid lightgrey;
  margin: auto;
  padding: 10px;
  border-radius: 5px;
  text-align: center;
  box-shadow: 5px 5px 10px 0.01px rgb(211, 211, 211);
}

.sell_name {
  font-size: 30px;
  font-weight: bolder;
  color: #fff;
}
.sell_num {
  font-size: 35px;
  color: #fff;
}
.sell_num_yuan {
  font-size: 30px;
  font-weight: bolder;
  color: #fff;
  margin-left: 5px;
}

.booking-data-area {
  display: flex;
  justify-content: center;
}
.booking-data-item {
  width: 150px;
  height: 150px;
  background-color: blanchedalmond;
  border: 1px solid lightgrey;
  margin: auto;
  padding: 10px;
  border-radius: 5px;
  box-shadow: 3px 3px 10px 0.01px rgb(231, 231, 231);
}
.booking-data-item-title {
  text-align: center;
  font-size: 13px;
  font-weight: bolder;
  color: #fff;
}
.booking-data-item-num {
  text-align: center;
  font-size: 60px;
  color: #fff;
}
.item-member-num {
  padding: 20px;
  font-size: 20px;
  font-weight: bolder;
  color: #ff5421;
}
</style>